import { EventEmitter } from 'fbemitter';

export const Events = {
  PROGRESS_ADDED: 'PROGRESS_ADDED',
  PROGRESS_UPDATED: 'PROGRESS_UPDATED',
  IMAGE_STATUS_CHANGED: 'IMAGE_STATUS_CHANGED',
  LOCATION_UPDATED: 'LOCATION_UPDATED',
  LOCATION_DELETED: 'LOCATION_DELETED',
  IMAGE_CLEAN_PROCESS_UPDATED: 'image_clean_process_updated',
  FORCE_LOGOUT: 'FORCE_LOGOUT',
  CHANGE_FLOOR_PLAN_2D_STYLE_NAME: 'CHANGE_FLOOR_PLAN_2D_STYLE_NAME',
  NEW_NOTIFICATION: 'new_notification',
  GEN_AI_IMAGE_STATUS_CHANGED: 'gen_ai_image_status_changed',
};

export default new EventEmitter();
